<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="订单状态">
<!--                  <el-input  v-model="queryForm.orderStatus"></el-input>-->
                  <el-select
                      style="width: 177px"
                      v-model="queryForm.orderStatus"
                      placeholder="请选择"
                      clearable
                      size="small"
                  >
                      <el-option v-for="(item, index) in statusList" :key="index" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getLifeChargingOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addLifeChargingOrder"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editLifeChargingOrder(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteLifeChargingOrder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--          <span title="导出数据" class="icon-box" @click="exportLifeChargingOrderList">-->
<!--                <Icon color="#606266">-->
<!--                    <ArrowDownload24Regular />-->
<!--                </Icon>-->
<!--            </span>-->
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshLifeChargingOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="lifeChargingOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="actualPrice"
        label="实际金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="returnMoney"
        label="退款金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderStatus"
        label="订单状态"
        width="180"
      >
          <template slot-scope="scope">
              {{getChargingValue(scope.row.orderStatus)}}
          </template>
      </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="chargingOrderId"
        label="来一票订单号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="chargingOrderSn"
        label="来一票订单号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="spOrderId"
        label="来一票退款单号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payTime"
        label="支付时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="finishTime"
        label="完成时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkLifeChargingOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editLifeChargingOrder(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteLifeChargingOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="lifeChargingOrderStates[lifeChargingOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="lifeChargingOrder"
          ref="lifeChargingOrderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="订单金额"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="lifeChargingOrder.orderPrice"
              :disabled="lifeChargingOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="实际金额"
            prop="actualPrice"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="lifeChargingOrder.actualPrice"
              :disabled="lifeChargingOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="退款金额"
            prop="returnMoney"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="lifeChargingOrder.returnMoney"
              :disabled="lifeChargingOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="lifeChargingOrder.userId"-->
<!--              :disabled="lifeChargingOrderState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="lifeChargingOrderState == 'check'" title="选择用户"
                           labelValue="id" :value="lifeChargingOrder.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="订单状态"
            prop="orderStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="lifeChargingOrder.orderStatus"-->
<!--              :disabled="lifeChargingOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 177px"
                  :disabled="lifeChargingOrderState == 'check'"
                  v-model="lifeChargingOrder.orderStatus"
                  placeholder="请选择"
                  clearable
                  size="small"
              >
                  <el-option v-for="(item, index) in statusList" :key="index" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
            <el-form-item
            label="来一票订单id"
            prop="chargingOrderId"
          >
                <el-input
                    size="small"
                    style="width: 177px"
                    v-model="lifeChargingOrder.chargingOrderId"
                    :disabled="lifeChargingOrderState == 'check'"
                ></el-input>
          </el-form-item>
          <el-form-item
            label="来一票订单号"
            prop="chargingOrderSn"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="lifeChargingOrder.chargingOrderSn"
              :disabled="lifeChargingOrderState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
            label="来一票退款单号"
            prop="spOrderId"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="lifeChargingOrder.spOrderId"
              :disabled="lifeChargingOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付时间"
            prop="payTime"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="lifeChargingOrder.payTime"-->
<!--              :disabled="lifeChargingOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="lifeChargingOrder.payTime"
                  type="datetime"
                  style="width: 177px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :disabled="lifeChargingOrderState == 'check'"
                  placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="完成时间"
            prop="finishTime"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="lifeChargingOrder.finishTime"-->
<!--              :disabled="lifeChargingOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="lifeChargingOrder.finishTime"
                  type="datetime"
                  style="width: 177px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :disabled="lifeChargingOrderState == 'check'"
                  placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="lifeChargingOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetLifeChargingOrderList();
                    this.getLifeChargingOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetLifeChargingOrderList();
                    this.getLifeChargingOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     orderPrice: '', //订单金额
                     actualPrice: '', //实际金额
                     returnMoney: '', //退款金额
                     userId: '', //用户ID
                     orderStatus: '', //订单状态(1-已支付,2-已完成,3-已退款)
                     chargingOrderSn: '', //来一票订单Id
                    spOrderId: '', //来一票退款单号
                     payTime: '', //支付时间
                     finishTime: '', //完成时间
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                lifeChargingOrderState: 'add',
                lifeChargingOrderStates: {
                    add: '新建充电站订单',
                    check: '查看充电站订单',
                    edit: '修改充电站订单'
                },

                multipleSelection: [],
                lifeChargingOrderList: [],
                lifeChargingOrder: {
                    id: '', //主键ID
                    orderPrice: '', //订单金额
                    actualPrice: '', //实际金额
                    returnMoney: '', //退款金额
                    userId: '', //用户ID
                    chargingOrderId: '',
                    appId: '', // appId
                    orderStatus: '', //订单状态(1-已支付,2-已完成,3-已退款)
                    chargingOrderSn: '', //来一票订单Id
                    spOrderId: '', // 来一票退款单号
                    payTime: '', //支付时间
                    finishTime: '', //完成时间
                },
                btnLoading: false,

                rules: {
                    orderPrice: [{ required: true, message: '订单金额不能为空', trigger: 'blur' }],
                    actualPrice: [{ required: true, message: '实际金额不能为空', trigger: 'blur' }],
                    returnMoney: [{ required: true, message: '退款金额不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    orderStatus: [{ required: true, message: '订单状态(1-已支付,2-已完成,3-已退款)不能为空', trigger: 'blur' }],
                    chargingOrderSn: [{ required: true, message: '来一票订单号不能为空', trigger: 'blur' }],
                    chargingOrderId: [{ required: true, message: '来一票订单id不能为空', trigger: 'blur' }],
                    spOrderId: [{ required: true, message: '来一票退款单号不能为空', trigger: 'blur' }],
                    payTime: [{ required: true, message: '支付时间不能为空', trigger: 'blur' }],
                    finishTime: [{ required: true, message: '完成时间不能为空', trigger: 'blur' }],
                },

                statusList: [],
            };
        },
        created() {
            this.getLifeChargingOrderList();
            this.getCharging();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value) {
                this.lifeChargingOrder.userId = value
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            getCharging(){
                get(`/life/utils/getEnum`,{"enumType": "charging_order_status"}).then((res) => {
                    if (res.success) {
                        this.statusList = res.enumList;
                    }
                });
            },
            getChargingValue(params) {
                for (let i = 0; i < this.statusList.length; i++){
                    if (this.statusList[i].key == params) {
                        return this.statusList[i].value
                    }
                }
            },
            resetLifeChargingOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.lifeChargingOrderList = [];
            },
            resetDialog() {
                this.lifeChargingOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      orderPrice: '', //订单金额
                      actualPrice: '', //实际金额
                      returnMoney: '', //退款金额
                      userId: '', //用户ID
                      orderStatus: '', //订单状态(1-已支付,2-已完成,3-已退款)
                      chargingOrderSn: '', //来一票订单Id
                      spOrderId: '',
                      payTime: '', //支付时间
                      finishTime: '', //完成时间
                };
                this.getLifeChargingOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.lifeChargingOrder = {
                      id: '', //主键ID
                      orderPrice: '', //订单金额
                      actualPrice: '', //实际金额
                      returnMoney: '', //退款金额
                      userId: '', //用户ID
                      appId: '', // appId
                      orderStatus: '', //订单状态(1-已支付,2-已完成,3-已退款)
                      chargingOrderSn: '', //来一票订单Id
                      spOrderId: '', // 来一票退款单号
                      payTime: '', //支付时间
                      finishTime: '', //完成时间
                    chargingOrderId: ''
                };
            },
            submitForm() {
                if (this.lifeChargingOrderState == 'add') {
                    this.$refs.lifeChargingOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/life/chargingorder/add`,{ ...this.lifeChargingOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetLifeChargingOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.lifeChargingOrderState == 'edit') {
                    this.$refs.lifeChargingOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.lifeChargingOrder.user
                            post(`/life/chargingorder/edit`,{ ...this.lifeChargingOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetLifeChargingOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addLifeChargingOrder() {
                this.showDialog = true;
                this.lifeChargingOrderState = 'add';
            },
            checkLifeChargingOrder(lifeChargingOrderId) {
                console.log(lifeChargingOrderId);
                this.currentLifeChargingOrderId = lifeChargingOrderId;

                this.getLifeChargingOrderById();
                this.showDialog = true;
                this.lifeChargingOrderState = 'check';
            },
            editLifeChargingOrder(lifeChargingOrderId) {
                console.log('lifeChargingOrder', lifeChargingOrderId);
                if (lifeChargingOrderId) {
                    this.currentLifeChargingOrderId = lifeChargingOrderId;
                    this.getLifeChargingOrderById();
                } else {
                    this.lifeChargingOrder = { ...this.lifeChargingOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.lifeChargingOrderState = 'edit';
            },
            deleteLifeChargingOrder(lifeChargingOrderId) {
                let ids = '';
                if (lifeChargingOrderId) {
                    ids = lifeChargingOrderId;
                } else {
                    ids = this.multipleSelection.map((lifeChargingOrder) => lifeChargingOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/life/chargingorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetLifeChargingOrderList();
                                this.getLifeChargingOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshLifeChargingOrderList() {
                this.resetLifeChargingOrderList();
                this.getLifeChargingOrderList();
            },
            getLifeChargingOrderList(query = {}) {
                this.loading = true;
                get(`/life/chargingorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.lifeChargingOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getLifeChargingOrderById() {
                get(`/life/chargingorder/get`,{ id: this.currentLifeChargingOrderId }).then((res) =>{
                    if(res.success){
                      this.lifeChargingOrder = { ...this.lifeChargingOrder, ...res.lifeChargingOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportLifeChargingOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/life/chargingorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/life/chargingorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/life/chargingorder/importData`,formData);
              this.refreshLifeChargingOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getLifeChargingOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getLifeChargingOrderList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>